import { NgModule } from '@angular/core';
import { BootstrapModule, BootstrapModuleContract, DatatablesModule, FormsModule, PluginService, SupportModule } from '@kaiser-software/chassis-core';
import { TaxService } from './services/tax.service';
import { TaxSettingsPlugin } from './plugins/tax-settings/tax-settings.plugin';
import { TaxRoutingModule } from './tax-routing.module';

@NgModule({
    imports: [
        FormsModule,
        DatatablesModule,
        SupportModule,
        TaxRoutingModule,
    ],
    declarations: [
        TaxSettingsPlugin,
    ],
    entryComponents: [
        TaxSettingsPlugin,
    ],
    providers: [
        TaxService,
    ],
    exports: [
        TaxSettingsPlugin,
    ]
})
export class TaxModule extends BootstrapModule implements BootstrapModuleContract {

    public plugins(plugins: PluginService) {
        plugins.add('form-tax-settings-plugin', 'form-tax-settings-plugin', TaxSettingsPlugin);
    }

}



// WEBPACK FOOTER //
// ./libs/donna-core/src/app/tax/tax.module.ts